export default "__VITE_ASSET__BXjROpjz__"